import { observer } from "mobx-react";
import { Button, Tag, Tooltip } from "antd";
import TitleBar from "../../../components/title_bar/TitleBar";
import styles from "./CrudFormStyles.module.scss";
import { translateKey as t } from "../../../locales/translation";
import { CrudHeaderProps } from "./CrudCommonTypes";

const CrudHeader = observer(
  ({
    controller,
    title,
    showDepotSelector,
    onCreate,
    onDepotChange,
    oldCrudURL,
    hideReadOnlyAlert,
  }: CrudHeaderProps) => {
    // let  depotSelected: boolean = false;

    const handleCreateButtonClick = () => {
      // once create button is clicked section is now CREATE
      controller.formMode = "create";

      // display form
      controller.setIsFormModalVisible(true);
      
      // run onCreate function
      onCreate();
    };

    const renderCreateButton = () => {
      // const isDisabled = (showDepotSelector && !depotSelected) || false;

      if (controller.isReadOnly) {
        return (
          <div>
            <Tooltip placement="left" title={t("lblThisCRUDIsSetAsReadOnly", "This CRUD is set as read-only")}>
              <Button data-e2e="header-add-btn" type="primary" icon="plus" style={{ height: "22px" }} disabled={true}>
                {t("lblAdd", "Add")} {title || t("lblItem", "Item")}
              </Button>
            </Tooltip>
          </div>
        );
      } else {
        return (
          <div>
            <Button
              data-e2e="header-add-btn"
              type="primary"
              icon="plus"
              onClick={handleCreateButtonClick}
              style={{ height: "22px" }}
              // disabled={isDisabled}
            >
              {t("lblAdd", "Add")} {title || t("lblItem", "Item")}
            </Button>
          </div>
        );
      }
    };

    const renderHeader = () => {
      return (
        <div style={{ fontSize: 12 }}>
          <h4 style={{ display: "inline", fontWeight: 600 }}>{title}</h4>
          {controller.isReadOnly && !hideReadOnlyAlert && (
            <Tooltip
              title={t(
                "lblYouAreViewingThisPageOnReadOnlyModeDuePermissionsAsItem",
                "You are viewing this page on read-only mode due to your permissions as {1}",
                [controller?.store?.user.roles[0]]
              )}
              placement="rightTop"
              arrow={{ pointAtCenter: true }}
            >
              <strong style={{ marginLeft: 5, verticalAlign: "super", textTransform: "uppercase", color: "#1976d2" }}>
                {t("lblReadOnly", "READ ONLY")}
              </strong>
            </Tooltip>
          )}
          {window.location.href?.indexOf("beta/") > -1 && (
            <Tooltip
              title="This page is still in BETA: some functionalities may not work as expected"
              placement="rightTop"
              arrow={{ pointAtCenter: true }}
            >
              <strong style={{ marginLeft: 5, verticalAlign: "super" }}>
                <Tag color="gold">BETA</Tag>
              </strong>
            </Tooltip>
          )}
        </div>
      );
    };

    return (
      <div>
        <TitleBar title={renderHeader()} rightPlaceholder={onCreate ? renderCreateButton() : null} />
      </div>
    );
  }
);

export { CrudHeader };
